import { toast } from "react-toastify";

export default class InvalidTokenError extends Error {
  constructor() {
    // Display a toast notification when the error is created
    toast.error("Token Expired. Please Login Again!", {
      autoClose: 5000, // 5 seconds
      pauseOnFocusLoss: false,
    });

    // Call the parent class constructor with a custom error message
    super("Token Expired. Please Login Again!");
    
    // Set the name of the error to 'InvalidTokenError' for easier identification
    this.name = "InvalidTokenError";
  }
}
